const bounce = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="455.583px" height="279.629px" viewBox="0 0 455.583 279.629" enable-background="new 0 0 455.583 279.629"
	 xml:space="preserve">
<g id="Layer_1">
	<rect x="-1794.699" y="-1089.944" fill="none" width="1920" height="2572.264"/>
	<g>
		<g opacity="0.5">
			<g>
				<defs>
					<rect id="SVGID_29_" x="120.939" y="232.212" width="108.916" height="47.417"/>
				</defs>
				<use xlink:href="#SVGID_29_"  overflow="visible" fill="#424242"/>
				<clipPath id="SVGID_2_">
					<use xlink:href="#SVGID_29_"  overflow="visible"/>
				</clipPath>
				<polygon clip-path="url(#SVGID_2_)" fill="#424242" points="229.808,253.371 229.808,232.211 198.897,232.211 194.479,232.211
					156.267,232.211 152.596,232.211 120.939,232.211 120.939,253.371 120.939,255.295 120.939,279.629 157.71,279.629
					159.94,279.629 188.854,279.629 193.039,279.629 229.854,279.629 229.854,253.371 				"/>
			</g>
		</g>
		<g>
			<g>
				<g opacity="0.3">
					<g>
						<defs>
							<rect id="SVGID_31_" x="115.603" y="172.321" width="224.75" height="49.31"/>
						</defs>
						<clipPath id="SVGID_3_">
							<use xlink:href="#SVGID_31_"  overflow="visible"/>
						</clipPath>
						<polygon clip-path="url(#SVGID_3_)" fill="none" stroke="#2E3192" stroke-miterlimit="10" points="237.14,172.816
							230.216,172.816 116.106,172.816 116.106,221.129 230.216,221.129 237.14,221.129 339.853,221.129 339.853,172.816 						"/>
					</g>
				</g>
				<g>
					<g opacity="0.3">
						<g>
							<defs>
								<rect id="SVGID_33_" x="229.964" y="225.24" width="110.629" height="49.32"/>
							</defs>
							<clipPath id="SVGID_5_">
								<use xlink:href="#SVGID_33_"  overflow="visible"/>
							</clipPath>

								<rect x="230.46" y="225.746" clip-path="url(#SVGID_5_)" fill="none" stroke="#2E3192" stroke-miterlimit="10" width="109.637" height="48.311"/>
						</g>
					</g>
					<g opacity="0.3">
						<g>
							<defs>
								<rect id="SVGID_35_" x="115.333" y="225.24" width="110.641" height="49.32"/>
							</defs>
							<clipPath id="SVGID_7_">
								<use xlink:href="#SVGID_35_"  overflow="visible"/>
							</clipPath>

								<rect x="115.833" y="225.746" clip-path="url(#SVGID_7_)" fill="none" stroke="#2E3192" stroke-miterlimit="10" width="109.637" height="48.311"/>
						</g>
					</g>
					<g opacity="0.3">
						<g>
							<defs>
								<rect id="SVGID_37_" x="344.442" y="172.321" width="110.641" height="49.31"/>
							</defs>
							<clipPath id="SVGID_8_">
								<use xlink:href="#SVGID_37_"  overflow="visible"/>
							</clipPath>

								<rect x="344.94" y="172.816" clip-path="url(#SVGID_8_)" fill="none" stroke="#2E3192" stroke-miterlimit="10" width="109.639" height="48.313"/>
						</g>
					</g>
					<g opacity="0.3">
						<g>
							<defs>
								<rect id="SVGID_39_" x="344.583" y="225.24" width="110.641" height="49.32"/>
							</defs>
							<clipPath id="SVGID_10_">
								<use xlink:href="#SVGID_39_"  overflow="visible"/>
							</clipPath>

								<rect x="345.085" y="225.746" clip-path="url(#SVGID_10_)" fill="none" stroke="#2E3192" stroke-miterlimit="10" width="109.639" height="48.311"/>
						</g>
					</g>
					<g opacity="0.3">
						<g>
							<defs>
								<rect id="SVGID_41_" x="114.724" y="67.961" width="340.859" height="101.24"/>
							</defs>
							<clipPath id="SVGID_11_">
								<use xlink:href="#SVGID_41_"  overflow="visible"/>
							</clipPath>
							<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" points="
								454.579,119.246 454.579,113.246 454.435,113.246 454.435,107.246 							"/>

								<line clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="10.762,10.762" x1="454.435" y1="96.483" x2="454.435" y2="80.34"/>
							<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" points="
								454.435,74.959 454.435,68.959 448.435,68.959 							"/>

								<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="12.1,12.1" points="
								436.333,68.959 358.259,68.959 344.519,68.959 225.638,68.959 214.212,68.959 127.772,68.959 							"/>
							<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" points="
								121.724,68.959 115.724,68.959 115.724,74.959 							"/>

								<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="12.463,12.463" points="
								115.724,87.422 115.724,113.246 115.724,117.271 115.724,155.969 							"/>
							<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" points="
								115.724,162.2 115.724,168.2 121.724,168.2 							"/>

								<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="12.106,12.106" points="
								133.829,168.2 230.122,168.2 237.063,168.2 327.021,168.2 340.036,168.2 442.526,168.2 							"/>
							<polyline clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" points="
								448.579,168.2 454.579,168.2 454.579,162.2 							"/>

								<line clip-path="url(#SVGID_11_)" fill="none" stroke="#2E3192" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="14.318,14.318" x1="454.579" y1="147.882" x2="454.579" y2="126.404"/>
						</g>
					</g>
				</g>
			</g>
			<g opacity="0.5">
				<g>
					<defs>
						<rect id="SVGID_43_" x="115.724" y="68.959" width="338.855" height="99.241"/>
					</defs>
					<clipPath id="SVGID_13_">
						<use xlink:href="#SVGID_43_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_13_)" fill="#08FCC9" points="454.43,113.244 454.43,68.957 358.256,68.957 344.517,68.957
						225.637,68.957 214.211,68.957 115.724,68.957 115.724,113.244 115.724,117.27 115.724,168.2 230.12,168.2 237.062,168.2
						327.018,168.2 340.033,168.2 454.574,168.2 454.574,113.244 					"/>
				</g>
			</g>
			<g opacity="0.5">
				<g>
					<defs>
						<rect id="SVGID_45_" x="116.837" y="172.816" width="222.53" height="48.065"/>
					</defs>
					<clipPath id="SVGID_15_">
						<use xlink:href="#SVGID_45_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_15_)" fill="#08FCC9" points="339.27,194.265 339.27,172.815 276.112,172.815 267.088,172.815
						189.018,172.815 181.515,172.815 116.837,172.815 116.837,194.265 116.837,196.214 116.837,220.881 191.963,220.881
						196.521,220.881 255.597,220.881 264.145,220.881 339.364,220.881 339.364,194.265 					"/>
				</g>
			</g>
			<g>
				<g>
					<defs>
						<rect id="SVGID_47_" x="115.07" y="226.212" width="108.916" height="47.417"/>
					</defs>
					<clipPath id="SVGID_16_">
						<use xlink:href="#SVGID_47_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_16_)" fill="#08FCC9" points="223.938,247.371 223.938,226.211 193.028,226.211
						188.609,226.211 150.397,226.211 146.727,226.211 115.07,226.211 115.07,247.371 115.07,249.295 115.07,273.629
						151.841,273.629 154.071,273.629 182.985,273.629 187.17,273.629 223.985,273.629 223.985,247.371 					"/>
				</g>
			</g>
			<g>
				<linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="63.2773" y1="252.2588" x2="63.2773" y2="0">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
					<stop  offset="1" style="stop-color:#08FCC9"/>
					<stop  offset="1" style="stop-color:#000000"/>
				</linearGradient>
				<path fill="url(#SVGID_18_)" d="M0.367,126.765C5.164,66.744,56.326,20.489,114.271,21.725L100.199,4.8l5.774-4.8l19.675,23.663
					c1.357,1.632,1.166,4.031-0.43,5.357l-23.096,19.204l-4.918-5.915l15.609-12.978C59.326,28.976,12.363,71.937,7.928,127.553
					c-4.671,58.492,39.021,111.044,97.383,117.128l-0.604,7.578C42.168,245.743-4.643,189.44,0.367,126.765z"/>
			</g>
			<g opacity="0.5">
				<g>
					<defs>
						<rect id="SVGID_50_" x="230.82" y="226.212" width="108.916" height="47.417"/>
					</defs>
					<clipPath id="SVGID_20_">
						<use xlink:href="#SVGID_50_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_20_)" fill="#08FCC9" points="339.688,247.371 339.688,226.211 308.778,226.211
						304.359,226.211 266.147,226.211 262.477,226.211 230.82,226.211 230.82,247.371 230.82,249.295 230.82,273.629
						267.591,273.629 269.821,273.629 298.735,273.629 302.92,273.629 339.735,273.629 339.735,247.371 					"/>
				</g>
			</g>
			<g opacity="0.5">
				<g>
					<defs>
						<rect id="SVGID_52_" x="344.196" y="226.212" width="108.916" height="47.417"/>
					</defs>
					<clipPath id="SVGID_22_">
						<use xlink:href="#SVGID_52_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_22_)" fill="#08FCC9" points="453.064,247.371 453.064,226.211 422.154,226.211
						417.735,226.211 379.523,226.211 375.853,226.211 344.196,226.211 344.196,247.371 344.196,249.295 344.196,273.629
						380.967,273.629 383.197,273.629 412.111,273.629 416.296,273.629 453.111,273.629 453.111,247.371 					"/>
				</g>
			</g>
			<g opacity="0.5">
				<g>
					<defs>
						<rect id="SVGID_54_" x="345.305" y="173.268" width="108.916" height="47.417"/>
					</defs>
					<clipPath id="SVGID_24_">
						<use xlink:href="#SVGID_54_"  overflow="visible"/>
					</clipPath>
					<polygon clip-path="url(#SVGID_24_)" fill="#08FCC9" points="454.173,194.427 454.173,173.267 423.263,173.267
						418.844,173.267 380.632,173.267 376.961,173.267 345.305,173.267 345.305,194.427 345.305,196.351 345.305,220.685
						382.075,220.685 384.306,220.685 413.22,220.685 417.404,220.685 454.22,220.685 454.22,194.427 					"/>
				</g>
			</g>
			
			<text transform="matrix(1 0 0 1 127.5527 255.9204)" fill="#636363" font-family="'Lato-Bold'" font-size="14">המודעה שלכם</text>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>

`;

export default bounce;



// WEBPACK FOOTER //
// ./src/Components/Modals/BounceMessage/img/bounceSvgString.js